/**
 * Google Tag Manager (GTM) CSS class names and data attributes
 * for tracking user interactions and behavior analytics.
 *
 * Usage:
 * - Use these constants instead of hardcoded strings
 */

// Navigation & Header Classes
export const GTM_LOGO = "gtm-logo";
export const GTM_NAV_MENU_LINK = "gtm-nav-menu__link";
export const GTM_NAV_MENU_LOGIN = "gtm-nav-menu__login";
export const GTM_HEADER_ACTION_SEARCH = "gtm-header-action__search";
export const GTM_HEADER_ACTION_BURGER = "gtm-header-action__burger";

// ISIN & Copy Action Classes
export const GTM_COPY_ISIN = "gtm-copy-isin";
export const GTM_COPY_ISIN_BUTTON = "gtm-copy-isin-button";
export const GTM_INVEST_BUTTON = "gtm-invest-button";

// User Action Classes
export const GTM_REGISTER = "gtm-register";

// Contact & Footer Classes
export const GTM_PHONE = "gtm-phone";
export const GTM_CONTACT_MAIL = "gtm-contact__mail";
export const GTM_FOOTER_SOCIAL_ICON = "gtm-footer__social-icon";

// GTM Data Attributes
export const GTM_DATA_ACTION = "data-gtm-action";
export const GTM_DATA_ISIN = "data-gtm-isin";
export const GTM_DATA_WIKIFOLIO_SHORT_DESCRIPTION = "data-gtm-wikifolio-short-description";

// Common GTM Action Values
export const GTM_ACTION_REGISTER = "register";
export const GTM_ACTION_REGISTER_MODULE = "register-module";
export const GTM_ACTION_HEADER_FOR_HOME = "header-for-home";
export const GTM_ACTION_INVEST_CLICK = "invest click";
export const GTM_ACTION_SHARE_WIKIFOLIO_CLICK = "share wikifolio click";
